import React from "react";
import { Box, Button } from "@mui/material";

const Legend = () => (
  <Box sx={{ mb: 2, display: "flex", gap: 1, alignItems: "center" }}>
    <Button
      variant="contained"
      sx={{
        backgroundColor: "#3174ad",
        color: "white",
        textTransform: "none",
        fontSize: "0.75rem",
        padding: "3px 10px",
        borderRadius: "5px",
        "&:hover": { backgroundColor: "#25507b" },
      }}
      disableElevation
    >
      Work Orders
    </Button>

    <Button
      variant="contained"
      sx={{
        backgroundColor: "#d32f2f",
        color: "white",
        textTransform: "none",
        fontSize: "0.75rem",
        padding: "3px 10px",
        borderRadius: "5px",
        "&:hover": { backgroundColor: "#9a2323" },
      }}
      disableElevation
    >
      Violations
    </Button>

    <Button
      variant="contained"
      sx={{
        backgroundColor: "#FFD700",
        color: "black",
        textTransform: "none",
        fontSize: "0.75rem",
        padding: "3px 10px",
        borderRadius: "5px",
        "&:hover": { backgroundColor: "#d4b200" },
      }}
      disableElevation
    >
      Architectural Request
    </Button>
  </Box>
);

export default Legend;
